<script>export let autoPlay = undefined;
export let muted = undefined;
export let controls = undefined;
export let loop = undefined;
export let playsInline = undefined;
export let preload = undefined;
export let attributes = undefined;
export let fit = undefined;
export let position = undefined;
export let aspectRatio = undefined;
export let video = undefined;
export let posterImage = undefined;
export let lazyLoad = undefined;
export let fitContent = undefined;
export let builderBlock = undefined;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
$: videoProps = () => {
    return {
        ...(autoPlay === true
            ? {
                autoPlay: true,
            }
            : {}),
        ...(muted === true
            ? {
                muted: true,
            }
            : {}),
        ...(controls === true
            ? {
                controls: true,
            }
            : {}),
        ...(loop === true
            ? {
                loop: true,
            }
            : {}),
        ...(playsInline === true
            ? {
                playsInline: true,
            }
            : {}),
    };
};
$: spreadProps = () => {
    return {
        ...videoProps(),
    };
};
</script>

<div
  style={stringifyStyles({
    position: "relative",
  })}
>
  <video
    style={stringifyStyles({
      width: "100%",
      height: "100%",
      ...attributes?.style,
      objectFit: fit,
      objectPosition: position,
      // Hack to get object fit to work as expected and
      // not have the video overflow
      zIndex: 2,
      borderRadius: "1px",
      ...(aspectRatio
        ? {
            position: "absolute",
          }
        : null),
    })}
    class="builder-video"
    {...spreadProps()}
    preload={preload || "metadata"}
    src={video || "no-src"}
    poster={posterImage}
  >
    {#if !lazyLoad}
      <source type="video/mp4" src={video} />
    {/if}</video
  >
  {#if aspectRatio && !(fitContent && builderBlock?.children?.length)}
    <div
      style={stringifyStyles({
        width: "100%",
        paddingTop: aspectRatio * 100 + "%",
        pointerEvents: "none",
        fontSize: "0px",
      })}
    />
  {/if}
  {#if builderBlock?.children?.length && fitContent}
    <div
      style={stringifyStyles({
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      })}
    >
      <slot />
    </div>
  {/if}
  {#if builderBlock?.children?.length && !fitContent}
    <div
      style={stringifyStyles({
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
      })}
    >
      <slot />
    </div>
  {/if}
</div>